'use strict';

import $ from 'jquery';
import Backbone from 'backbone';

var MyArrowTM = Backbone.View.extend({

  initialize: function() {
    if (this.model.get('isMyArrowUser') && this.model.get('isFromLogin')) {
      this.$el.find('.ProgressBar').each(function() {
        $(this).addClass('ProgressBar--animate');
      });
      this.$el.find('.Icon--my-arrow-tm').each(function() {
        /* Cannot add both classes right after one another to make
           the transition appear as designed. Setting a 1ms delay allows the
           transition to be noticed by the user.
        */
        $(this).addClass('MyArrowLink');
        setTimeout(() => {
          $(this).addClass('MyArrowLink--animate');
        }, 1);
      });
    }
  }
});

module.exports = MyArrowTM;



// WEBPACK FOOTER //
// ./assets/components/Header/js/MyArrowTM.js